import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api, { IMAGE_BASE_URL } from "../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./BlogDetails.css";
const AddBlogPageDetails = () => {

  const imagePath = `${IMAGE_BASE_URL}/uploads/blogs/`;

  const { pageID } = useParams();
  const blogId = pageID;

 const [getBlogLink, setBlogLink] = useState("");
  const [title, setTitle] = useState("");
  const [sbTitle, setSbTitle] = useState("");
  const [description, setDescription] = useState("");
  const [content, setContent] = useState("");
  const [getBlogDate, setBlogDate] = useState("");

    const [getCategory, setCategory] = useState("");
      const [getTags, setTags] = useState("");
  const [getMetaKey, setMetaKey] = useState("");
  const [getMetaDescription, setMetaDescription] = useState("");
    const [getKeyword, setKeyword] = useState("");
const [autherName, setAutherName] = useState("");
  const [getblogdata, setblogdata] = useState([]);

  // FIXED STATE
  const [featured, setFeatured] = useState([]);


  useEffect(() => {
    fetchBlogDataEdit();
  }, []);

const fetchBlogDataEdit = async () => {
  try {
    const res = await api.get(`/adminBlog/getblogDataEdit/${blogId}`);

    const data = res.data?.data || [];

    const blogLink = data[0]?.blogLink;
    const title = data[0]?.title;
    const sub_title = data[0]?.sub_title;
    const pageContent = data[0]?.pageContent;
    const description = data[0]?.description;
    const addedDt = data[0]?.addedDt;
    const pageimg = data[0]?.pageimg || "";
    const extraImages = data[0]?.extraImages || "[]"; 

    const metaKey = data[0]?.metaKey;
    const metaDescription = data[0]?.metaDescription;
    const keyword = data[0]?.keyword;
  const autherNameSet = data[0]?.autherName;
  const category = data[0]?.category;
const tags = data[0]?.tags || "[]";

const resultTags = JSON.parse(tags)
  .map(tag =>
    tag
      .split("-")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  )
  .join(", ");

setTags(resultTags);
    setblogdata(data);
    setCategory(category);
    // setTags(tags);
    setTitle(title);
    setSbTitle(sub_title);
    setDescription(description);
    setContent(pageContent);
    setBlogDate(addedDt);
    setBlogLink(blogLink);

    setMetaKey(metaKey);
    setMetaDescription(metaDescription);
    setKeyword(keyword);
    setAutherName(autherNameSet);

    // SPLIT MAIN IMAGES
    const imageArray = pageimg ? pageimg.split(",") : [];

    setFeatured(imageArray);

    // =============================
    // SET EXTRA IMAGES FOR EDIT
    // =============================
    // extraImages comes as JSON string like:
    // '[{"image":"img1.jpg","altTitle":"title1"}, {"image":"img2.jpg","altTitle":"title2"}]'

    let extraImagesArray = [];
    try {
      // extraImagesArray = JSON.parse(extraImages).map(item => item.image, item => item.altTitle);
      extraImagesArray = JSON.parse(extraImages || "[]").map(item => ({
    image: item.image,
    altTitle: item.altTitle
  }));
    } catch (err) {
      console.error("Failed to parse extraImages:", err);
    }

    // Merge or set separately as needed
    setFeatured(prev => [...prev, ...extraImagesArray]); // merge with main images if needed

    console.log("Extra images loaded:", extraImagesArray);

  } catch (error) {
    toast.error("Failed to load blog data");
  }
};







return (
  <div className="container-fluid py-4 bg-light min-vh-100">

    {/* Header */}

    <div className="card border-0 shadow-sm mb-4">
      <div className="card-body d-flex justify-content-between align-items-center">

        <div>
          <h3 className="fw-bold mb-0">
            Blog Details
          </h3>

          <small className="text-muted">
            View complete blog information
          </small>
        </div>

        <Link
          to="/blog-manage"
          className="btn btn-outline-dark d-flex align-items-center gap-2"
        >
          <ArrowLeft size={18} />
          Back
        </Link>

      </div>
    </div>

    <div className="row justify-content-center">

      <div className="col-lg-12">
   <div className="mb-3">

              <span className="badge bg-primary px-3 py-2">

                <i className="fa fa-link me-2"></i>

                {getBlogLink}

              </span>

            </div>

            {/* Title */}

            <h1 className="fw-bold mb-2 blog-title">
              {title}
            </h1>

            {/* Subtitle */}

            <h5 className="text-muted mb-4">
              {sbTitle}
            </h5>
        <div className="card border-0 shadow-sm overflow-hidden">

          {/* Carousel */}

          <div
            id="featuredCarousel"
            className="carousel slide"
            data-bs-ride="carousel"
          >

            {featured.length > 1 && (
              <div className="carousel-indicators">

                {featured.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    data-bs-target="#featuredCarousel"
                    data-bs-slide-to={index}
                    className={
                      index === 0 ? "active" : ""
                    }
                  ></button>
                ))}

              </div>
            )}

            <div className="carousel-inner">

              {featured.map((item, index) => (

                <div
                  key={index}
                  className={`carousel-item ${
                    index === 0 ? "active" : ""
                  }`}
                >

                  <img
                    src={`${imagePath}${item.image}`}
                    alt={item.altTitle}
                    title={item.altTitle}
                    className="w-100 blog-banner-image"
                  />

                </div>

              ))}

            </div>

            {featured.length > 1 && (
              <>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#featuredCarousel"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon"></span>
                </button>

                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#featuredCarousel"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon"></span>
                </button>
              </>
            )}

          </div>

          {/* Content */}

          <div className="card-body p-4 p-lg-5">

            {/* Blog Link */}

         

            {/* Meta Info */}

            <div className="d-flex flex-wrap gap-3 mb-4 blog-meta" style={{textTransform: "capitalize"}}>

              <span>
                <i className="fa fa-user text-primary me-2"></i>
                {autherName}
              </span>

              <span>
                <i className="fa fa-calendar text-danger me-2"></i>

                {new Date(getBlogDate)
                  .toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
              </span>

            

            </div>
{/* category and tag section start */}
  <div className="card bg-light border-0 mb-4">

              <div className="card-body">


                <p className="mb-2">
                  <strong>Category :</strong>
                  {" "}
                   {getCategory
    ?.replace(/-/g, " ")
    ?.replace(/\b\w/g, (char) => char.toUpperCase())
  }
                  
                </p>

                <p className="mb-0">
                  <strong>
                    Tags :
                  </strong>
                  {" "}
                  {getTags}
                </p>

             

              </div>

            </div>
{/* category and tag section end */}
{/* SEO Section */}

            <div className="card bg-light border-0 mb-4">

              <div className="card-body">

                <h5 className="fw-bold mb-3">
                  SEO Information
                </h5>

                <p className="mb-2">
                  <strong>Meta Title:</strong>
                  {" "}
                  {getMetaKey}
                </p>

                <p className="mb-0">
                  <strong>
                    Meta Description:
                  </strong>
                  {" "}
                  {getMetaDescription}
                </p>

                <p className="mb-0">
                  <strong>
                    Meta Keyword:
                  </strong>
                  {" "}
                  {getKeyword}
                </p>

              </div>

            </div>
            {/* Description */}

            <div className="blog-description mb-4">

              <p  style={{marginTop:"1px",textAlign:"justify"}}>{description}</p>

            </div>

            

            {/* Main Content */}

            <div
              className="blog-content"
              dangerouslySetInnerHTML={{
                __html: content
              }}
            ></div>

          </div>

        </div>

      </div>

    </div>

  </div>
);
};

export default AddBlogPageDetails;